export const COSMIC_THEME = {
	name: 'cosmic',
	base: 'default',
	variables: {}
};
